module.exports = __webpack_public_path__ + "static/media/ai-page-hero-2.648746bd.png";